<template>
  <b-modal
    size="md"
    centered
    lazy
    :title="title"
    header-bg-variant="info"
    footer-border-variant="info"
    v-model="show"
    :hide-footer="true"
  >
    <b-container>

      <b-input-group class="mb-3">
        <b-form-input
          v-model="filter"
          @keyup.enter="findAll"
          placeholder="Procurar por..."
        />
        <b-input-group-append>
          <b-button size="md" text="Button" variant="outline-info" @click.passive="findAll">
            <i class="cui-magnifying-glass"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <div v-if="loadingRows" class="mb-5 pb-5">
        <loading-animation />
      </div>

      <div v-if="!loadingRows && !users.length">
        <div class="row bg-light mx-0 py-3">
          <div class="col text-center">
            Nenhum usuário encontrado
          </div>
        </div>
      </div>

      <div v-if="!loadingRows && users.length" class="mb-3">
        <div
          v-for="(user, index) in users"
          class="row py-3 border mx-0 cursor-pointer"
          :key="index"
          :class="{
            'bg-primary': currentSeparatorId === user.id,
            'bg-light': currentSeparatorId != user.id && index % 2 != 0
          }"
          @click="selectUser(user)"
        >
          <div class="col-auto">
            <span class="font-weight-bold">Código: </span>{{user.ref}}
          </div>
          <div class="col-sm">
            <span class="font-weight-bold">Nome: </span>{{user.name}}
          </div>
        </div>
      </div>

      <nav>
        <b-pagination
          v-if="totalRows"
          align="center"
          :limit="3"
          :total-rows="totalRows"
          :per-page="perPage"
          prev-text="Anterior"
          next-text="Próximo"
          v-model="currentPage"
          @change="pageChanged"
          :disabled="loadingRows"/>
      </nav>

    </b-container>
  </b-modal>
</template>

<script>
import { httpClient } from '@/service'
import { LoadingAnimation } from '@/components/loaders'
import shared from '@/shared/shared'

const RECENT_USERS_KEY = "recent_users";
const DEFAULT_CONDITIONS = [
  {
    field: 'type',
    value: 'U'
  },
  {
    field: 'active',
    value: true
  }
];
const DEFAULT_SELECT = ['id', 'ref', 'name'];

export default {
  name: 'separator-user-selection-modal',
  components: {
    LoadingAnimation
  },

  props: {
    separatorChanged: {
      type: Function
    },
  },

  data() {
    return {
      show: false,
      order: undefined,
      users: [],
      loadingRows: false,
      currentPage: 1,
      perPage: 5,
      totalRows: null,
      filter: '',
      saving: false,
      recentUsers: []
    }
  },

  created() {
    this.loadRecentUsers();
  },

  computed: {
    title() {
      let prefix = 'Definir';
      let temp = ' usuário separador do pedido ';

      if (this.order) {
        if (this.order.number) {
          temp += this.order.number;
        } else if (this.order.documentNumber) {
          temp += this.order.documentNumber;
        }

        if (this.order.separatorUser && this.order.separatorUser.id) {
          prefix = 'Alterar';
        }
      }

      return prefix + temp;
    },

    currentSeparatorId() {
      return this.order && this.order.separatorUser && this.order.separatorUser.id;
    }
  },

  methods: {
    showModal(order) {
      this.show = true;
      this.order = order;

      if (!this.users || !this.users.length) {
        this.findAll();
      }
    },

    hideModal() {
      this.show = false;
    },

    findAll() {
      let conditions = JSON.parse(JSON.stringify(DEFAULT_CONDITIONS));

      if (this.filter && this.filter.length) {
        conditions.push({
          logicalOperator: 'OR',
          conditions: [
            {
              field: 'name',
              conditionalOperator: 'LIKE',
              value: this.filter
            },
            /*{
              field: 'email',
              conditionalOperator: 'LIKE',
              value: this.filter
            }*/
            {
              field: 'ref',
              conditionalOperator: 'LIKE',
              value: this.filter
            }
          ]
        });
      }

      this.loadingRows = true;
      httpClient.post(
        `${process.env.VUE_APP_API_URL}users/select-and-where?page=${this.currentPage - 1}&size=${this.perPage}`, {
        select: DEFAULT_SELECT,
        where: {
          conditions: conditions,
          orderBies: [
            {
              direction: 'ASC',
              condition: { field: 'ref' }
            },
            {
              direction: 'ASC',
              condition: { field: 'name' }
            }
          ]
        }
      }).then(({ data }) => {
        this.loadingRows = false;
        this.users = data.data.content;
        this.totalRows = data.data.totalElements;

        if (this.currentPage === 1 && this.users && this.recentUsers) {
          this.recentUsers.forEach(user => {
            if (!this.users.find(u => u.id === user.id)) {
              this.users.unshift(user);
            }
          });
        }
      })
      .catch((error) => {
        this.loadingRows = false;
        if (error.message) {
          this.$notify.error(error)
        }
        this.users = [];
      });
    },

    pageChanged(page) {
      this.currentPage = page;
      this.findAll();
    },

    selectUser(user) {
      if (!user || !user.id || this.saving) return;

      if (!this.recentUsers.find(u => u.id === user.id)) {
        this.recentUsers.push(user);
        this.saveRecentUsers();
      }

      this.saving = true;
      httpClient.patch(`${process.env.VUE_APP_API_URL}orders/${this.order.id}`, {
        separatorUserId: user.id
      })
      .then(({ data }) => {
        this.saving = false;
        this.$notify.success('Usuário separador alterado para ' + user.ref + ' - ' + user.name);
        this.hideModal();

        if (this.separatorChanged) {
          this.separatorChanged(this.order, user);
        }
      })
      .catch((error) => {
        console.error(error);
        this.saving = false;
        if (error.message) {
          this.$notify.error(error)
        }
      });
    },

    saveRecentUsers() {
      shared.setLocalStorageObj(RECENT_USERS_KEY, this.recentUsers);
    },

    loadRecentUsers() {
      let temp = shared.getLocalStorageObj(RECENT_USERS_KEY);

      if (!Object.values(temp).length) {
        temp = [];
      }

      if (temp && Array.isArray(temp) && temp.length) {
        //Consulta novamente os usuários recentes no back para eliminar os usuários inativo e deletados
        let conditions = JSON.parse(JSON.stringify(DEFAULT_CONDITIONS));
        conditions.push({
          field: 'id',
          conditionalOperator: 'IN',
          value: temp.map(u => u.id)
        });

        httpClient.post(
          `${process.env.VUE_APP_API_URL}users/select-and-where?page=0&size=${temp.length}`, {
          select: DEFAULT_SELECT,
          where: {
            conditions: conditions
          }
        }).then(({ data }) => {
          if (data.data.content) {
            this.recentUsers = data.data.content;
          }
        })
        .catch((error) => {
          console.error(error);
          if (error.message) {
            this.$notify.error(error)
          }
        });
      }
    }
  }
}
</script>
